import Cookies from 'js-cookie';

const cookie = {
	setItem(key, value) {
		const deNormalizeValue = JSON.parse(value);
		const { data, expires } = deNormalizeValue[key];
		const normalizeValue = {
			[key]: data,
		};
		const normalizeData = JSON.stringify(normalizeValue);
		Cookies.set(key, normalizeData, { expires, path: '/' });
	},
	// mergeItem: function (key, value) {
	// },
	getItem(key) {
		return Cookies.get(key);
	},
};

export default cookie;
